import { Button, Input, Typography, message } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminModel, adminApi } from "../../entities/Admin";
import { Token } from "../../entities/Admin/model";

interface props {
  setIsAuth: (auth: boolean) => void;
}

const AuthComponent = (props: props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useDispatch();

  useEffect(() => {
    let tokenStr = localStorage.getItem("token");
    if (tokenStr && tokenStr != "undefined") {
      let token: Token = JSON.parse(tokenStr);
      adminApi
        .adminInfo(token)
        .then((res) => {
          // we don't set token here, because if token was refreshed
          // then it will be set in $api.interceptors, otherwise,
          // token was not refreshed so we don't need to set new token
          if (res.data.user) {
            dispatch(adminModel.setUser(res.data.user));
          }
          props.setIsAuth(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const onSubmit = () => {
    adminApi
      .adminSignin(username, password)
      .then((response) => {
        if (response.data.token) {
          dispatch(adminModel.setUser(response.data.user));
          dispatch(adminModel.setToken(response.data.token));
          messageApi.success("user authorized");
          props.setIsAuth(true);
        }
      })
      .catch((e) => {
        console.log("error", e);
        dispatch(adminModel.setUser(null));
        messageApi.error(e.response.data);
      });
  };
  return (
    <div
      style={{
        width: 400,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {contextHolder}

      <Typography.Text style={{ fontWeight: 600, marginTop: 10, fontSize: 17 }}>
        Войти
      </Typography.Text>
      <Input
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="Login"
        style={{ marginTop: 10 }}
      />
      <Input
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ marginTop: 10 }}
      />
      <Button
        type="primary"
        style={{ marginTop: 10, width: "100%" }}
        onClick={onSubmit}
      >
        Войти
      </Button>
    </div>
  );
};

export default AuthComponent;
